// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scene-video-container {
  position: absolute;
  top: 0;
  z-index: -5;
  width: 100%;
  overflow: hidden;
}

.scene-video {
  height: calc(61vh + 400px);
  width: auto;
}

.scene-gradient {
  background-image: url(/public/assets/images/home_gradient.png);
  background-position: center;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: absolute;
  top: 0;
  height: 100vh;
  width: 100vw;
  z-index: -1;
}

.scene-white-wedge {
  background-image: url(/public/assets/images/home_white_wedge.svg);
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  position: absolute;
  top: 61vh;
  height: 100vh;
  width: 100vw;
  z-index: -1;
}

#home {
  position: relative;
  top: 12vh;
}

#home .intro {
  padding: 6% 10%;
}

#home .intro .title-container {
  padding-left: 15%;
  padding-right: 15%;
  padding-bottom: 80px;
}

#home .intro .title {
  font-family: 'Cinzel', serif;
  color: #ffffff;
  font-size: 40px;
  margin-bottom: 40px;
  text-align: center;
}

#home .intro .subtitle {
  font-family: 'Avenir';
  color: #ffffff;
  font-weight: 400;
  text-align: center;
}

#home .intro .subtitle .bold {
  font-family: 'Avenir-Black';
}


#home .getInTouch{
  margin-bottom: 20px;
}
#home .getInTouch div#default-btn{
  background-color: rgb(245, 176, 65);
}

#home .intro .cards-container {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-bottom: 20px;
}

#home .intro .card {
  width: 240px;
  height: 340px;
  background-color: #ffffff;
  padding: 20px 25px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  box-shadow: 2px 2px 20px #616161;
  margin-bottom: 15px;
}

#home .intro .card img {
  height: 85px;
  margin: 30px;
  margin-bottom: 10px;
}

#home .intro .card h4 {
  font-size: 18px;
  margin-bottom: 5px;
}

#home .intro .card .detail {
  font-size: 12px;
  color: #1d2027;
}
#home .intro .card a:not(.text-center) {
  align-self: flex-end;
  text-decoration: none;
}

#home .intro .card a .read-more {
  width: 100%;
  font-size: 12px;
  font-weight: 700;
  color: #000078;
  cursor: pointer;
}

#home .intro .card .read-more:hover {
  opacity: 0.8;
}

#home .philosophy {
  background-image: url(/public/assets/icons/dots_right.png);
  background-repeat: no-repeat;
  background-size: 150px;
  background-position-x: 90%;
  background-position-y: 20%;
  background-color: #f4f4f4;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  padding: 6%;
}

#home .philosophy .title {
  color: #464646;
  font-family: 'Cinzel', serif;
  font-size: 36px;
  margin-bottom: 45px;
}

#home .philosophy img {
  height: 85px;
  margin-bottom: 60px;
}

#home .philosophy img.dots {
  height: 180px;
  position: absolute;
  right: 6%;
  top: 136vh;
}

#home .philosophy .details-container {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  width: 100%;
  flex-wrap: wrap;
}

#home .philosophy .details-container .detail {
  width: 220px;
  margin-bottom: 20px;
  text-align: center;
  color: #464646;
  font-size: 15px;
  font-style: italic;
}

#home .internships {
  background-image: url(/public/assets/icons/dots_left.png);
  background-repeat: no-repeat;
  background-size: 150px;
  background-position-x: 10%;
  background-position-y: 20%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  padding: 6%;
  margin-bottom: 12vh;
}

#home .internships .title {
  color: #464646;
  font-family: 'Cinzel', serif;
  font-size: 36px;
  margin-bottom: 45px;
}

#home .internships img {
  height: 85px;
  margin-bottom: 60px;
}

#home .internships .general-intro {
  padding: 0 18%;
  text-align: center;
  font-size: 14px;
  color: #464646;
  margin-bottom: 40px;
}

#home .internships .cards-container {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  width: 100%;
}

#home .internships .cards-container .card {
  width: 380px;
  height: 360px;
  background-color: #ffffff;
  padding: 25px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  box-shadow: 2px 2px 20px #616161;
  margin-bottom: 15px;
}

#home .internships .cards-container .card h4 {
  font-size: 18px;
}

#home .internships .cards-container .card p {
  font-size: 13px;
  text-align: center;
}

#home .internships #default-btn {
  width: 100%;
}

@media (max-width: 627px) {
  #home .intro .cards-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 20px;
  }
}

@media (max-width: 768px) {
  #home{
    top: 20vh;
  }
  #header img {
    margin-left: auto;
  }
  #home .intro .title-container {
    padding-left: 0;
    padding-right: 0;
  }
}
@media (min-width: 420px) {
}
@media (min-width: 576px) {
}
@media (min-width: 768px) {
}
@media (min-width: 992px) {
  .scene-gradient {
    width: 100vw;
  }

  .scene-white-wedge {
    width: 100vw;
  }
}
@media (min-width: 1200px) {
}
`, "",{"version":3,"sources":["webpack://./client/styles/Home.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,8DAA8D;EAC9D,2BAA2B;EAC3B,0BAA0B;EAC1B,4BAA4B;EAC5B,kBAAkB;EAClB,MAAM;EACN,aAAa;EACb,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,iEAAiE;EACjE,2BAA2B;EAC3B,sBAAsB;EACtB,4BAA4B;EAC5B,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;EAC5B,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;;AAGA;EACE,mBAAmB;AACrB;AACA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,8BAA8B;EAC9B,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,0DAA0D;EAC1D,4BAA4B;EAC5B,sBAAsB;EACtB,0BAA0B;EAC1B,0BAA0B;EAC1B,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yDAAyD;EACzD,4BAA4B;EAC5B,sBAAsB;EACtB,0BAA0B;EAC1B,0BAA0B;EAC1B,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,eAAe;EACf,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,6BAA6B;EAC7B,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,SAAS;EACX;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;AACA;AACA;AACA;AACA;AACA;AACA;AACA;EACE;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;AACF;AACA;AACA","sourcesContent":[".scene-video-container {\n  position: absolute;\n  top: 0;\n  z-index: -5;\n  width: 100%;\n  overflow: hidden;\n}\n\n.scene-video {\n  height: calc(61vh + 400px);\n  width: auto;\n}\n\n.scene-gradient {\n  background-image: url(/public/assets/images/home_gradient.png);\n  background-position: center;\n  background-size: 100% 100%;\n  background-repeat: no-repeat;\n  position: absolute;\n  top: 0;\n  height: 100vh;\n  width: 100vw;\n  z-index: -1;\n}\n\n.scene-white-wedge {\n  background-image: url(/public/assets/images/home_white_wedge.svg);\n  background-position: center;\n  background-size: cover;\n  background-repeat: no-repeat;\n  position: absolute;\n  top: 61vh;\n  height: 100vh;\n  width: 100vw;\n  z-index: -1;\n}\n\n#home {\n  position: relative;\n  top: 12vh;\n}\n\n#home .intro {\n  padding: 6% 10%;\n}\n\n#home .intro .title-container {\n  padding-left: 15%;\n  padding-right: 15%;\n  padding-bottom: 80px;\n}\n\n#home .intro .title {\n  font-family: 'Cinzel', serif;\n  color: #ffffff;\n  font-size: 40px;\n  margin-bottom: 40px;\n  text-align: center;\n}\n\n#home .intro .subtitle {\n  font-family: 'Avenir';\n  color: #ffffff;\n  font-weight: 400;\n  text-align: center;\n}\n\n#home .intro .subtitle .bold {\n  font-family: 'Avenir-Black';\n}\n\n\n#home .getInTouch{\n  margin-bottom: 20px;\n}\n#home .getInTouch div#default-btn{\n  background-color: rgb(245, 176, 65);\n}\n\n#home .intro .cards-container {\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  margin-bottom: 20px;\n}\n\n#home .intro .card {\n  width: 240px;\n  height: 340px;\n  background-color: #ffffff;\n  padding: 20px 25px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n  box-shadow: 2px 2px 20px #616161;\n  margin-bottom: 15px;\n}\n\n#home .intro .card img {\n  height: 85px;\n  margin: 30px;\n  margin-bottom: 10px;\n}\n\n#home .intro .card h4 {\n  font-size: 18px;\n  margin-bottom: 5px;\n}\n\n#home .intro .card .detail {\n  font-size: 12px;\n  color: #1d2027;\n}\n#home .intro .card a:not(.text-center) {\n  align-self: flex-end;\n  text-decoration: none;\n}\n\n#home .intro .card a .read-more {\n  width: 100%;\n  font-size: 12px;\n  font-weight: 700;\n  color: #000078;\n  cursor: pointer;\n}\n\n#home .intro .card .read-more:hover {\n  opacity: 0.8;\n}\n\n#home .philosophy {\n  background-image: url(/public/assets/icons/dots_right.png);\n  background-repeat: no-repeat;\n  background-size: 150px;\n  background-position-x: 90%;\n  background-position-y: 20%;\n  background-color: #f4f4f4;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n  align-items: center;\n  padding: 6%;\n}\n\n#home .philosophy .title {\n  color: #464646;\n  font-family: 'Cinzel', serif;\n  font-size: 36px;\n  margin-bottom: 45px;\n}\n\n#home .philosophy img {\n  height: 85px;\n  margin-bottom: 60px;\n}\n\n#home .philosophy img.dots {\n  height: 180px;\n  position: absolute;\n  right: 6%;\n  top: 136vh;\n}\n\n#home .philosophy .details-container {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-around;\n  width: 100%;\n  flex-wrap: wrap;\n}\n\n#home .philosophy .details-container .detail {\n  width: 220px;\n  margin-bottom: 20px;\n  text-align: center;\n  color: #464646;\n  font-size: 15px;\n  font-style: italic;\n}\n\n#home .internships {\n  background-image: url(/public/assets/icons/dots_left.png);\n  background-repeat: no-repeat;\n  background-size: 150px;\n  background-position-x: 10%;\n  background-position-y: 20%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n  align-items: center;\n  padding: 6%;\n  margin-bottom: 12vh;\n}\n\n#home .internships .title {\n  color: #464646;\n  font-family: 'Cinzel', serif;\n  font-size: 36px;\n  margin-bottom: 45px;\n}\n\n#home .internships img {\n  height: 85px;\n  margin-bottom: 60px;\n}\n\n#home .internships .general-intro {\n  padding: 0 18%;\n  text-align: center;\n  font-size: 14px;\n  color: #464646;\n  margin-bottom: 40px;\n}\n\n#home .internships .cards-container {\n  display: flex;\n  justify-content: space-around;\n  flex-wrap: wrap;\n  width: 100%;\n}\n\n#home .internships .cards-container .card {\n  width: 380px;\n  height: 360px;\n  background-color: #ffffff;\n  padding: 25px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-around;\n  box-shadow: 2px 2px 20px #616161;\n  margin-bottom: 15px;\n}\n\n#home .internships .cards-container .card h4 {\n  font-size: 18px;\n}\n\n#home .internships .cards-container .card p {\n  font-size: 13px;\n  text-align: center;\n}\n\n#home .internships #default-btn {\n  width: 100%;\n}\n\n@media (max-width: 627px) {\n  #home .intro .cards-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin-bottom: 20px;\n  }\n}\n\n@media (max-width: 768px) {\n  #home{\n    top: 20vh;\n  }\n  #header img {\n    margin-left: auto;\n  }\n  #home .intro .title-container {\n    padding-left: 0;\n    padding-right: 0;\n  }\n}\n@media (min-width: 420px) {\n}\n@media (min-width: 576px) {\n}\n@media (min-width: 768px) {\n}\n@media (min-width: 992px) {\n  .scene-gradient {\n    width: 100vw;\n  }\n\n  .scene-white-wedge {\n    width: 100vw;\n  }\n}\n@media (min-width: 1200px) {\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
